import { getEstDateString } from '../../helpers';
const paymentDateConfig = () => {
    const paymentScheduledDate = new Date();
    const payOffDate = getEstDateString(paymentScheduledDate);
    return ['paymentDate', payOffDate, 'ENABLED', []];
};
export default paymentDateConfig;
